import moment from "moment-timezone";
export default {
    isNumber(event) {
        event = event ? event : window.event;
        var charCode = event.which ? event.which : event.keyCode;
        if (charCode >= 48 && charCode <= 57) {
            return true;
        } else {
            event.preventDefault();
            return false;
        }
    },
    formatNumber(value, dicimal) {
        if (isNaN(parseFloat(value))) {
            return value;
        } else {
            if (value % 1 == 0) {
                return parseFloat(value).toLocaleString(undefined, {
                    minimumFractionDigits: dicimal,
                    maximumFractionDigits: dicimal
                });
            } else {
                let parts = value.toString().split(".");
                let num = (parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ","));
                let digit = parts[1].slice(0, 2);
                digit = digit.length < 2 ? digit + "0" : digit;
                return num + "." + digit;
            }
        }
    },
    formatDate(date, format) {
        return moment(date).format(format);
    }
}